import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import {  OneClickPurchaseComponent } from './one-click-purchase.component';

@NgModule({
  imports: [
    CommonModule,
    
    MatIconModule,
    MatButtonModule
  ],
  exports: [
    OneClickPurchaseComponent
  ],
  providers: [
  ],
  declarations: [
    OneClickPurchaseComponent
  ]
})
export class OneClickPurchaseModule { }
